import "./index.css";
import React, { Suspense } from "react";


import { Navbar } from "./components/NavBar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
const Gallery = React.lazy(() => import('./components/Gallery').then(mod => ({ default: mod.Gallery })))
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsappButton } from "./components/WhatsappButton";

export function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Suspense fallback={null}>
          <Gallery />
        </Suspense>
        <Contact />
        <WhatsappButton />
      </main>
      <Footer />
    </div>
  );
}

export default App;
